import { IpexMomentEnum } from '@insights/insights-data-provider';
import { moduleClient } from '../../contexts/insights';
export const sendInsightsEvent = (type, event, payload) => {
    moduleClient?.sendEvent({
        ipexMoment: IpexMomentEnum[type],
        event: event,
        payload: payload
    });
};
//# sourceMappingURL=sendInsights.js.map